// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"539aa164","481":"bd45e46f","950":"ad6ae6f6","992":"9ce58b8f"}[chunkId] + ".chunk.js";
};